import { Component, Input } from '@angular/core';
import { CustomjsService } from '../../service/customjs.service';
import { UserService } from '../../service/user.service';

@Component({
  selector: 'bevvi-flashmessage',
  templateUrl: './flashmessage.component.html',
  styleUrls: ['./flashmessage.component.scss']
})
export class FlashmessageComponent{

  @Input() errorMsg: string;
  @Input() successMsg:string;

  public orientationPage: string;
  public pageYOffset: number;

  constructor(
    private customJS: CustomjsService,
    private userService: UserService
  ) {
    this.userService.flashMessageSubject
    .subscribe(
      data => {
        // console.log('FLash MESSAGE SUBJECT: ' + data);
        if (data) {
          this.customJS.showToastMsg();
          // if (this.customJS.checkIfVisible()) {
          //   this.customJS.hideFlashMsg();
          //   this.customJS.showFlashMsg();
          //   this.customJS.hideFlashMsgAfter2s();
          // } else {
          //   this.customJS.showFlashMsg();
          //   this.customJS.hideFlashMsgAfter2s();
          // }
        }
      }
    )
   }

  // checkPageInfo() {
  //   console.log(window.innerWidth);

  //   window.addEventListener("orientationchange", function() {
  //     // Announce the new orientation number
  //     if (window.orientation === 90) {
  //       console.log('Landscape');
  //     }
  //     if (window.orientation === 0) {
  //       console.log('potrait');
  //     }
  //   }, false);

  //   window.addEventListener("resize", function() {
  //     // Announce the new orientation number
  //     console.log(window.innerWidth);
  //   }, false);
    
  // }

  close() {
    this.customJS.hideFlashMsg();
  }

}
